var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"app"}},[_c('h2',[_vm._v("薪资收益计算器")]),_c('Calculator'),_c('h2',[_vm._v("可视化收益")]),_c('Charts'),_c('h2',[_vm._v("参考")]),_c('References'),_c('h2',[_vm._v("公式源代码")]),_c('Formula')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }